var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M8.49984 8.48697L9.729 10.362C9.89567 10.5911 9.83317 10.9036 9.604 11.0495C9.37484 11.2161 9.06234 11.1536 8.9165 10.9245L7.58317 8.92447C7.52067 8.84114 7.49984 8.73697 7.49984 8.6328V5.79947C7.49984 5.52864 7.70817 5.29947 7.99984 5.29947C8.27067 5.29947 8.49984 5.52864 8.49984 5.79947V8.48697ZM13.3332 8.6328C13.3332 11.5911 10.9373 13.9661 7.99984 13.9661C5.0415 13.9661 2.6665 11.5911 2.6665 8.6328C2.6665 5.6953 5.0415 3.29947 7.99984 3.29947C10.9373 3.29947 13.3332 5.6953 13.3332 8.6328ZM7.99984 4.29947C5.604 4.29947 3.6665 6.2578 3.6665 8.6328C3.6665 11.0286 5.604 12.9661 7.99984 12.9661C10.3748 12.9661 12.3332 11.0286 12.3332 8.6328C12.3332 6.2578 10.3748 4.29947 7.99984 4.29947Z",
    fill: "#2E2E2E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.ad3e0380f989e83b167a7c0f1577dc2b.svg";
export { ForwardRef as ReactComponent };